import { Show } from 'solid-js';
import { useTheme } from '../theme/ThemeProvider';

/**
 * Glassmorphism Background Component
 * Renders floating orbs for the glassmorphism theme
 * Only visible when glassmorphism theme is active
 */
export function GlassmorphismBackground() {
  const theme = useTheme();

  return (
    <Show when={theme.preset() === 'glassmorphism'}>
      <>
        <div class="glassmorphism-orb glassmorphism-orb--1" aria-hidden="true" />
        <div class="glassmorphism-orb glassmorphism-orb--2" aria-hidden="true" />
        <div class="glassmorphism-orb glassmorphism-orb--3" aria-hidden="true" />
        <div class="glassmorphism-orb glassmorphism-orb--4" aria-hidden="true" />
      </>
    </Show>
  );
}
